<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="customerService"
    [idKey]="'customerId'"
></base-index-page>